import { render, staticRenderFns } from "./MemberEmptyLink.vue?vue&type=template&id=995262e6&scoped=true&"
import script from "./MemberEmptyLink.vue?vue&type=script&lang=js&"
export * from "./MemberEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995262e6",
  null
  
)

export default component.exports